import script from "./CommunicationSourceProviderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunicationSourceProviderModal.vue?vue&type=script&setup=true&lang=js"

import "./CommunicationSourceProviderModal.vue?vue&type=style&index=0&id=5823d267&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5823d267"]])

export default __exports__